import * as Yup from "yup";
import { getBlockedTextWarning } from "../../../../core/constants/constants";

export interface DescriptionFormValues {
	description: string;
}

const buildBlockedTextTest = (field: string) =>
	function (this: Yup.TestContext, value?: string) {
		if (!value || value.trim().length === 0) return true;
		const blockedReason = getBlockedTextWarning(value, field);
		if (!blockedReason) return true;
		return this.createError({ message: blockedReason });
	};

export const descriptionValidationSchema = Yup.object({
	description: Yup.string()
		.max(1000, "Description cannot exceed 1000 characters")
		.test("blocked-description", "", buildBlockedTextTest("Description")),
});
